import React, { useContext, useLayoutEffect } from 'react';
import { HomeScreenUser } from './HomeScreenUser';
import { HomeScreenBusiness } from './HomeScreenBusiness';
import PageWrapper from '#/components/PageWrapper/PageWrapper';
import { useMeQuery } from '@streamster/shared/api/api.portal';
import { AuthContext } from '@streamster/shared/screens/auth/auth.utils';
import { HomeScreenAdmin } from '#/screens/home/HomeScreenAdmin';
import { useAppNavigation } from '@streamster/shared/navigation/navigation.ref';
import { isWhiteLabelMode } from '@streamster/shared/utils';
import { useManagerPermissions } from '@streamster/shared/hooks/use-manager-permissions';

const HomeScreen: React.FC<{}> = () => {
  const { webAuth } = useContext(AuthContext);
  const { data: profile } = useMeQuery();
  const { isManager } = useManagerPermissions();
  const navigation = useAppNavigation();

  useLayoutEffect(() => {
    if (isWhiteLabelMode()) {
      navigation.navigate('ActiveStream');
    }
  }, [navigation, isWhiteLabelMode()]);

  if (!profile) {
    return null;
  }

  return (
    <PageWrapper>
      {webAuth?.admin ? (
        <HomeScreenAdmin />
      ) : profile?.business || isManager ? (
        // A manager gets the business dashboard (streamer list + switcher), scoped and gated
        // to their assigned streamers and granted permissions.
        <HomeScreenBusiness />
      ) : (
        <HomeScreenUser />
      )}
    </PageWrapper>
  );
};

export default HomeScreen;
